<template>
  <svg
    id="Email_success"
    data-name="Email success"
    xmlns="http://www.w3.org/2000/svg"
    width="110"
    height="110"
    viewBox="0 0 110 110"
  >
    <path
      id="Path_8673"
      data-name="Path 8673"
      d="M0,0H110V110H0Z"
      fill="none"
    />
    <path
      id="Path_8674"
      data-name="Path 8674"
      d="M3,9.355V50.811A11.916,11.916,0,0,0,14.917,62.728H73.583A11.916,11.916,0,0,0,85.5,50.811V9.355"
      transform="translate(10.75 33.522)"
      fill="none"
      :stroke="mailBorder"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8677"
      data-name="Path 8677"
      d="M64.742,7h9.964A10.792,10.792,0,0,1,85.5,17.794h0a10.792,10.792,0,0,1-4.735,8.933c-6.137,4.162-17.137,11.619-26.24,17.788a18.308,18.308,0,0,1-20.556,0C25.142,38.529,13.95,30.939,7.725,26.722A10.77,10.77,0,0,1,3,17.794H3A10.792,10.792,0,0,1,13.794,7h9.964"
      transform="translate(10.75 25.083)"
      fill="none"
      :stroke="mailBorder"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8675"
      data-name="Path 8675"
      d="M28.126,2A20.626,20.626,0,0,1,48.751,22.62a20.948,20.948,0,0,1-20.63,20.63,20.625,20.625,0,0,1,0-41.25"
      transform="translate(26.879 7.166)"
      fill="none"
      stroke="#00b947"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8676"
      data-name="Path 8676"
      d="M26.283,5.628,16.254,15.656,10.241,9.638"
      transform="translate(36.697 20.168)"
      fill="none"
      stroke="#00b947"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
<script>
export default {
  props: ["mailBorder"]
};
</script>
